import gsap from 'gsap'

export class Preloader {
  constructor() {
    this.el = document.getElementById('preloader')
    if (!this.el) return

    this.logo = this.el.querySelector('.preloader-logo')
    this.bg = this.el.querySelector('.preloader-bg')
    this.headerLogo = document.querySelector('.header-logo')
    this.exiting = false

    // Centre le logo via GSAP (évite le conflit avec un CSS transform)
    gsap.set(this.logo, { xPercent: -50, yPercent: -50 })

    if (this.headerLogo) {
      gsap.set(this.headerLogo, { opacity: 0 })
    }

    // Si le preloader a déjà été vu dans cette session, on le passe directement
    if (sessionStorage.getItem('preloaderSeen')) {
      gsap.set(this.el, { opacity: 0 })
      this.el.classList.add('is-done')
      if (this.headerLogo) {
        gsap.set(this.headerLogo, { opacity: 1 })
      }
      return
    }

    document.body.style.overflow = 'hidden'

    this.animate()
  }

  animate() {
    // Logo fade in au centre
    gsap.to(this.logo, {
      opacity: 1,
      duration: 1.2,
      ease: 'power2.out',
      delay: 0.5,
    })

    // Clic n'importe où pour skipper
    this.el.addEventListener('click', () => this.exit())

    // Auto-exit après 5 secondes
    this.timer = setTimeout(() => this.exit(), 5000)
  }

  exit() {
    if (this.exiting) return
    this.exiting = true
    clearTimeout(this.timer)

    const startRect = this.logo.getBoundingClientRect()
    const endRect = this.headerLogo.getBoundingClientRect()

    // Mouvement center-to-center pour rester cohérent avec xPercent/yPercent
    const startCX = startRect.left + startRect.width / 2
    const startCY = startRect.top + startRect.height / 2
    const endCX = endRect.left + endRect.width / 2
    const endCY = endRect.top + endRect.height / 2
    const scale = endRect.width / startRect.width

    const tl = gsap.timeline()

    // Logo vole vers la position du header
    tl.to(this.logo, {
      x: endCX - startCX,
      y: endCY - startCY,
      scale,
      duration: 1,
      ease: 'power3.inOut',
    })

    // Fondu du fond en parallèle (légèrement décalé)
    tl.to(this.bg, {
      opacity: 0,
      duration: 0.9,
      ease: 'power2.inOut',
    }, 0.2)

    // Swap logo préloader → logo header, retire l'overlay
    tl.add(() => {
      gsap.to(this.logo, { opacity: 0, duration: 0.15 })
      if (this.headerLogo) {
        gsap.to(this.headerLogo, { opacity: 1, duration: 0.3 })
      }
      gsap.to(this.el, {
        opacity: 0,
        duration: 0.4,
        ease: 'power2.out',
        onComplete: () => {
          this.el.classList.add('is-done')
          document.body.style.overflow = ''
          sessionStorage.setItem('preloaderSeen', '1')
        },
      })
    }, '-=0.15')
  }
}
